import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import { useDropzone2 } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"
import { saveCustomerPortalForm1 } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";
import { updateCustomerPortalForm1 } from "assets/globalAPI/apiGlobal";
import { fetchKDSCustomer } from "assets/globalAPI/apiGlobal";
import { fetchKDSMaterial } from "assets/globalAPI/apiGlobal";
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import {Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";
import {Table} from "react-bootstrap"
import {FormGroup, FormControlLabel} from "@mui/material";

const CustomerFormEdit=()=>{
    const navigate= useNavigate();
    const [loaderspinner, setLoaderSpinner] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [customerType, setCustomerType] = useState("");
     const [searchLoader, setSearchLoader] = useState(false);
    const toastId = React.useRef(null);
    const [loader, setLoader] = useState(false);
    const [formSubmitted, setIsFormSubmiteed] = useState(false);
    const contactEmail= localStorage.getItem("contactPersonEmail")
    const contactMobile= localStorage.getItem("contactPersonMobile")
    const [refID, setRefID] = useState(localStorage.getItem("reference_id") || ""); 
    const [enabledFields, setEnabledFields]= useState([]);
    const [kdsdata,setKdsData]= useState({});
        const [kdsdata2,setKdsData2]= useState({});
        const [kdsdata3,setKdsData3]= useState({});
        const [dialogOpen,setDialogOpen]= useState(false);
        const [dialogOpen2,setDialogOpen2]= useState(false);
        const [searchTerm,setSearchTerm]= useState("");
        const [searchTerm2,setSearchTerm2]= useState("");
         const [keySelected,setKeySelected]= useState("");
         const [godownUnit,setGodownUnit]= useState("");
              const [customerState,setCustomerState]= useState([])
              const [filteredZone,setFilteredZone]= useState([])
              const [custTitle,setCustTitle]= useState([])
              const [titleName,setTitleName]= useState("");
              const [debouncedSearch, setDebouncedSearch] = useState("");
         
              const [zData,setZData]= useState([]);
              const [selectedField,setSelectedField]= useState("");
              const [stateSelected,setStateSelected]=useState("")
              const [selectedZoneName,setSelectedZoneName]=useState("")
              const [selectedKeyName,setSelectedKeyName]=useState("")
              const [userID,setUserID]=useState("");
const [panGSTError,setPanGSTError]= useState(false);
                        const [panGSTError2,setPanGSTError2]= useState(false);
    const [formValues, setFormValues] = useState({
          reference_id: '',
          firm_name: '',
          firm_status:'',
          street: '',
          co_name:'',
          po_box: '', 
          city: '',
          district_name: '',
          block_tehsil: '',
          main_town_village: '', 
          post_office: '', 
          police_station: '',
          state: '', // State*
          pin_code: '', // Pin Code*
          proprietor_name: '', 
          proprietor_dob: '', 
          proprietor_email: contactEmail, 
          proprietor_mobile: contactMobile, 
          pan: '', 
          aadhaar: '', 
          cin: '', 
          roc_status:'', 
          inpln: '', 
          contact_person: '', 
          contact_person_email: '', 
          contact_person_mobile: '',
          mobile:contactMobile?.toString(),
          email:contactEmail,
          contact_person_telephone: '',
          fssi_registration_status: '', 
          fssi_regn_no: '', 
          gstn: '', 
          tan: '', 
          bank_name: '',
          bank_branch_name: '',
          ifsc_code: '', // IFSC Code
          bank_account_number: '',
          undated_cheque_1: '',
          undated_cheque_2: '',
          undated_cheque_3: '',
          miscellaneous: '',
          companies: [
            { name_of_company: '', company_brand: '', monthly_turnover: '' }
          ],
          godown_area: '',
          godown_type: '',
          rcc_structure: '',
          del_type_rickshaw:'',
          del_type_van:'',
          model_no_van:'',
          customer_salesman_1: '',
          customer_salesman_no_1: '',
          customer_salesman_2: '',
          customer_salesman_no_2: '',
          customer_weekoff: '',
          date_of_fillup: new Date().toISOString().split('T')[0].replaceAll("-", ""),
    
          marketDetails: {
            Monday: [
              {
                beatName_1: "",
                distanceFromGodown_1: "",
                expectedDailySales_1: "",
                retailer_1: "",
                wholesaler_1: "",
                frequencyOfVisit_1: "",
                readyStockOrOrderBooking_1: "",
                beatName_2: "",
                distanceFromGodown_2: "",
                expectedDailySales_2: "",
                retailer_2: "",
                wholesaler_2: "",
                frequencyOfVisit_2: "",
                readyStockOrOrderBooking_2: ""
              }
            ],
            Tuesday: [
              {
                beatName_1: "",
                distanceFromGodown_1: "",
                expectedDailySales_1: "",
                retailer_1: "",
                wholesaler_1: "",
                frequencyOfVisit_1: "",
                readyStockOrOrderBooking_1: "",
                beatName_2: "",
                distanceFromGodown_2: "",
                expectedDailySales_2: "",
                retailer_2: "",
                wholesaler_2: "",
                frequencyOfVisit_2: "",
                readyStockOrOrderBooking_2: "",
              }
            ],
            Wednesday: [
              {
                beatName_1: "",
                distanceFromGodown_1: "",
                expectedDailySales_1: "",
                retailer_1: "",
                wholesaler_1: "",
                frequencyOfVisit_1: "",
                readyStockOrOrderBooking_1: "",
                beatName_2: "",
                distanceFromGodown_2: "",
                expectedDailySales_2: "",
                retailer_2: "",
                wholesaler_2: "",
                frequencyOfVisit_2: "",
                readyStockOrOrderBooking_2: "",
              }
             
            ],
            Thursday: [
              {
                beatName_1: "",
                distanceFromGodown_1: "",
                expectedDailySales_1: "",
                retailer_1: "",
                wholesaler_1: "",
                frequencyOfVisit_1: "",
                readyStockOrOrderBooking_1: "",
                beatName_2: "",
                distanceFromGodown_2: "",
                expectedDailySales_2: "",
                retailer_2: "",
                wholesaler_2: "",
                frequencyOfVisit_2: "",
                readyStockOrOrderBooking_2: "",
              },
            ],
            Friday: [
              {
                beatName_1: "",
                distanceFromGodown_1: "",
                expectedDailySales_1: "",
                retailer_1: "",
                wholesaler_1: "",
                frequencyOfVisit_1: "",
                readyStockOrOrderBooking_1: "",
                beatName_2: "",
                distanceFromGodown_2: "",
                expectedDailySales_2: "",
                retailer_2: "",
                wholesaler_2: "",
                frequencyOfVisit_2: "",
                readyStockOrOrderBooking_2: "",
              },
            ],
            Saturday: [
              {
                beatName_1: "",
                distanceFromGodown_1: "",
                expectedDailySales_1: "",
                retailer_1: "",
                wholesaler_1: "",
                frequencyOfVisit_1: "",
                readyStockOrOrderBooking_1: "",
                beatName_2: "",
                distanceFromGodown_2: "",
                expectedDailySales_2: "",
                retailer_2: "",
                wholesaler_2: "",
                frequencyOfVisit_2: "",
                readyStockOrOrderBooking_2: "",
              },
            ],
            Sunday: [
              {
                beatName_1: "",
                distanceFromGodown_1: "",
                expectedDailySales_1: "",
                retailer_1: "",
                wholesaler_1: "",
                frequencyOfVisit_1: "",
                readyStockOrOrderBooking_1: "",
                beatName_2: "",
                distanceFromGodown_2: "",
                expectedDailySales_2: "",
                retailer_2: "",
                wholesaler_2: "",
                frequencyOfVisit_2: "",
                readyStockOrOrderBooking_2: "",
              },
            ],
          },
        });

        function formatDate(value) {
          if (!value) return '';
        
          // If value is already in YYYYMMDD format
          if (typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value)) {
            const year = value.substring(0, 4);
            const month = value.substring(4, 6);
            const day = value.substring(6, 8);
            return `${year}-${month}-${day}`;
          }
        
          // If value is in YYYY-MM-DD or similar format
          const dateObj = new Date(value);
        
          // If date is valid, format it
          if (!isNaN(dateObj.getTime())) {
            return dateObj.toISOString().split('T')[0];
          }
        
          // If invalid, don't touch it. Let the user keep typing.
          return value;
        }

          useEffect(() => {
              const handler = setTimeout(() => {
                setSearchLoader(true); // Show loader AFTER 2 sec pause
                setDebouncedSearch(searchTerm);
            
                // Simulate async filtering (optional delay or set false immediately after)
                setTimeout(() => {
                  setSearchLoader(false); // Hide loader after data is "ready"
                }, 100); // tweak delay if needed
              }, 600); // Wait for user to stop typing
            
              return () => clearTimeout(handler); // Cleanup if typing again
            }, [searchTerm]);
          
            useEffect(() => {
              const handler = setTimeout(() => {
                setSearchLoader(true); // Show loader AFTER 2 sec pause
                setDebouncedSearch(searchTerm2);
            
                // Simulate async filtering (optional delay or set false immediately after)
                setTimeout(() => {
                  setSearchLoader(false); // Hide loader after data is "ready"
                }, 100); // tweak delay if needed
              }, 600); // Wait for user to stop typing
            
              return () => clearTimeout(handler); // Cleanup if typing again
            }, [searchTerm2]);


         const fetchAllCustomerKDS=async()=>{
                        try{
                          const response= await fetchKDSMaterial();
                          const res= response.data;
                          if(res.status){
                            setKdsData(res.data)
                            console.log("kds fetched>> ", res.data);
                          }else{
                            console.log("could not bring material kds>> ", res)
                          }
                        }catch(error){
                          console.log("error bringing material KDS>> ", error);
                        }
                      }

                      const fetchAllCustomerKDS2=async()=>{
                                                    try{
                                                      const response= await fetchKDSCustomer();
                                                      const res= response.data;
                                                      if(res.status){
                                                        setKdsData2(res.data)
                                                        setCustTitle(res.data.title)
                                                        setCustomerState(res.data.region)
                                                        setZData(res.data.miszone)
                                                        console.log("kds fetched for cust>> ", res.data);
                                                      }else{
                                                        console.log("could not bring cust kds>> ", res)
                                                      }
                                                    }catch(error){
                                                      console.log("error bringing cust KDS>> ", error);
                                                    }
                                                  }

    const fetchCustomers=async()=>{
        setIsActive(true)
        const body={
          page: 1,
          reference_id: refID
        }

        console.log("cust fetch body>> ", body)
    
        try{
          const response= await fetchAllCustomer(body);
          const res= response.data;
          console.log("printing res>>> ", res);
          if(res.status){
            setIsActive(false)
            console.log("fetched custs>> ", res.data);
            const newValues = { ...formValues };
            Object.keys(newValues).forEach((key) => {
                if (res.data[0].hasOwnProperty(key)) {
                    newValues[key] = res.data[0][key];
                    const [area, unit] = res.data[0].godown_area.split(" ");
                    setGodownUnit(unit); 
                }
            });
            
            // Handling companies separately
            if (res.data[0].companies && Array.isArray(res.data[0].companies)) {
                newValues.companies = res.data[0].companies.map(company => ({
                    name_of_company: company.name_of_company || '',
                    company_brand: company.company_brand || '',
                    monthly_turnover: company.monthly_turnover || ''
                }));
            }

            
            // Handling marketDetails separately
            if (res.data[0].marketDetails && Array.isArray(res.data[0].marketDetails && res.data[0].marketDetails.length>0)) {
                const marketDetails = {
                    Monday: [],
                    Tuesday: [],
                    Wednesday: [],
                    Thursday: [],
                    Friday: [],
                    Saturday: [],
                    Sunday: []
                };
            
                res.data[0].marketDetails.forEach((detail) => {
                  const day = detail.day;
                  if (marketDetails[day]) {
                    marketDetails[day].push(detail);
                  }
                });
        
                newValues.marketDetails = marketDetails;

            }else{
              newValues.marketDetails= formValues.marketDetails
            }

            newValues.approval_status = "pending";
            newValues.customer_status = "0";
            
            setFormValues(newValues);

            console.log("here is new values>> ", newValues)

          }else{
            console.log("not fetched custs>> ", res);
            setIsActive(false)
          }
        }catch(error){
            setIsActive(false)
          console.log("err in cust fetch>> ", error);
           if(error.response?.status==403){
                      if(!toast.isActive(toastId.current)){
                        toastId.current= toast.error("Your Session has expired",{
                          className:"small-toast"
                        })
                      }
                      setTimeout(()=>{
                        navigate("/")
                      },2000)
                      return;
                    }
        }
      }


     useEffect(() => {
          if (refID) {
            setFormValues((prevValues) => ({
              ...prevValues,
              reference_id: refID,
            }));
            console.log("ref id is>> ", refID)
          }
        }, [refID]);

    useEffect(() => {

      // const isAuthenticate= localStorage.getItem("isAuthenticated");
      // if(!isAuthenticate){
      //   navigate("/customer/edit/validation");
      //   return;
      // }
      let cust_type= localStorage.getItem("customer_type");
      console.log("hvgdhw>> ", cust_type)
      // let userHere= JSON.parse(localStorage.getItem("userdetails"))
      // setUserID(userHere.id)
      fetchCustomers();
      fetchAllCustomerKDS()
      fetchAllCustomerKDS2();
      
        setCustomerType(cust_type);
        let localForm = localStorage.getItem("customerForm2");
      let parsedFrom= JSON.parse(localForm)
      console.log("what is in form>>> ", JSON.parse(localForm))
      if(parsedFrom!==null){
        setFormValues(JSON.parse(localForm))
      }

      let selectedForm = JSON.parse(localStorage.getItem("selected_fields"));
      if(selectedForm){
        setEnabledFields(selectedForm);
      }
    },[]);

    const filteredData = kdsdata.matuom?.filter(
      (item) =>
        item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
        item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
    );


    const isFieldEnabled = (fieldName) => enabledFields.includes(fieldName);

    function capitalizeInitials(str) {
      return str
        .split(/(\s+)/) // this keeps the spaces too
        .map(word => {
          return word.trim() ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;
        })
        .join('');
    }
    

  //   const handleFormChange = (field, value) => {
  //     let updatedValue = value;
  
  //     // Check if the field is one of the multi-selects
  //     if (field === "nature_of_business" || field === "business_category") {
  //         // For multi-select fields, we need to extract the 'value' from the selected options array
  //         updatedValue = value.map(option => option.value);
  //     }
  
  //     // Update the state for the given field
  //     setFormValues((prevState) => ({
  //         ...prevState,
  //         [field]: {
  //             ...prevState[field],
  //             value: updatedValue,
  //         },
  //     }));
  // };

  const handleFormChange = (field, value, index = null, day = null) => {
    if(field==="godown_unit"){
      setGodownUnit(value)
      setFormValues(prev => ({
        ...prev,
        godown_area: prev.godown_area.split(" ")[0] + (value ? ` ${value}` : ""),
        
      }));
      setDialogOpen(false)
      return;
    }

    if (field === "godown_area") {
        console.log("god unit>> ", godownUnit)
        setFormValues((prev) => ({
            ...prev,
            [field]: value + (godownUnit ? ` ${godownUnit}` : ""),
            
        }));

        return;
    }
    setFormValues((prevState) => {
        let updatedState = { ...prevState };

        // Update companies only if index is provided and day is null
        if (index !== null && day === null) {
          const updatedCompanies = [...prevState.companies];
          updatedCompanies[index] = {
              ...updatedCompanies[index],
              [field]: value,
          };
          updatedState.companies = updatedCompanies;
      } 
        
        // Update marketDetails only if day is provided
        else if (day !== null && index !== null) {
          const updatedDays = { ...prevState.marketDetails };
          updatedDays[day][index] = {
              ...updatedDays[day][index],
              [field]: value,
          };
          updatedState.marketDetails = updatedDays;
          
      } 
        // General field update
        else {
          updatedState[field] = value;
          setSearchTerm2("")
          setSearchTerm("")
      }
      setDialogOpen2(false)
      setDialogOpen(false)
        console.log("here is formValues after change>> ", formValues)
        // setDialogOpen(false)

        return updatedState;
    });
};




  // const handleFormChange = (index, field, value) => {
  //   setFormValues((prevState) => {
  //     const updatedCompanies = [...prevState.companies];
  //     updatedCompanies[index] = {
  //       ...updatedCompanies[index],
  //       [field]: { ...updatedCompanies[index][field], value },
  //     };
  //     return { ...prevState, companies: updatedCompanies };
  //   });
  // };

  const addRow = () => {
    setFormValues((prevState) => ({
      ...prevState,
      companies: [
        ...prevState.companies,
        { name_of_company: '', company_brand: '', monthly_turnover: '' }
      ],
    }));
  };

  const addRowMarket = (day) => {
    setFormValues((prevState) => {
      const updatedDays = { ...prevState.marketDetails };
      updatedDays[day].push({
        beatName: "",
        distanceFromGodown: "",
        expectedDailySales: "",
        retailer: "",
        wholesaler: "",
        frequencyOfVisit: "",
        readyStockOrOrderBooking: "",
      });
  
      return { ...prevState, marketDetails: updatedDays };
    });
  };

  const removeRowMarket = (day, index) => {
    setFormValues((prevState) => {
      const updatedDays = { ...prevState.marketDetails };
      
      if (updatedDays[day].length > 1) {
        updatedDays[day].splice(index, 1);
      }
  
      return { ...prevState, marketDetails: updatedDays };
    });
  };
  
  
  
  const removeRow = (index) => {
    setFormValues((prevState) => {
      const updatedCompanies = prevState.companies.filter((_, i) => i !== index);
      return { ...prevState, companies: updatedCompanies };
    });
  };
  

     const handleSubmitForm=async(e)=>{
             e.preventDefault();
             setIsActive(true)
             console.log("here is the final form>> ", formValues)
             setIsFormSubmiteed(true);
             const requiredFields = [
               "firm_name", "firm_status",  "street","city","district_name",
               "state", "pin_code", "proprietor_name", "proprietor_email", "proprietor_mobile","proprietor_dob","gstn", "pan",
               "contact_person", "contact_person_email", "contact_person_mobile"
             ];
     
             const godownAreaFilled = formValues.godown_area && formValues.godown_area.trim() !== '';
             const godownUnitFilled = godownUnit && godownUnit.trim() !== '';
     
             
             
             let hasError = false;
             let updatedValues = { ...formValues };
             let missingFields = [];
             
             requiredFields.forEach((key) => {
           if (godownAreaFilled) {
             if(!godownUnitFilled){
               hasError = true;
               missingFields.push("godown_unit");
             }
            //  hasError = true;
            //  if (!godownAreaFilled) missingFields.push("godown_area");
           }
           const value = updatedValues[key];
         
           if (typeof value === 'string') {
             if (value.trim() === '') {
               hasError = true;
               missingFields.push(key.replace(/_/g, ' '));
             } else {
               updatedValues[key] = value.trim();
             }
           } else if (value === undefined || value === null) {
             hasError = true;
             missingFields.push(key.replace(/_/g, ' '));
           }
         });
         
     
         setFormValues(updatedValues); 
          if (hasError) {
               console.log("cannot submit, fill mandatory")
               if (!toast.isActive(toastId.current)) {
                 toastId.current = toast.warning(`Please fill all required fields: ${missingFields}`, {
                   className: "small-toast"
                 });
               }
               
               setIsActive(false);
               
               return;
             }
     
             console.log("here is the final form>> ", formValues)
             localStorage.setItem("customerForm", JSON.stringify(formValues))
             localStorage.setItem("customerForm2", JSON.stringify(formValues))
             // localStorage.setItem("filledForm2", JSON.stringify(formValues))
             // alert("Registration sucessful");
             // navigate("/customer/registration-form-2")
     
     
     
             try{
               const response= await updateCustomerPortalForm1(formValues);
               const res= response.data;
               console.log("here is response>> ", res);
               if(res.status){
                 if (!toast.isActive(toastId.current)) {
                   toastId.current = toast.success(res.message, {
                     className: "small-toast"
                   });
                 }
                 setIsActive(false)
                 localStorage.setItem("reference_id", refID)
                 console.log("success in submitting>> ", res)
                 navigate("/customer/edit/registration-form-2")
               }else{
                 if (!toast.isActive(toastId.current)) {
                   toastId.current = toast.warning(res.message, {
                     className: "small-toast"
                   });
                 }
                 setIsActive(false)
                 console.log("not success in submitting>> ", res)
               }
             }catch(error){
               console.log("Error saving customer details>> ", error);
                if (!toast.isActive(toastId.current)) {
                       toastId.current = toast.error(error.message, {
                         className: "small-toast"
                       });
                     }
                     setIsActive(false)
             }
           }

    return(
      <>
     <Grid>
      <ToastContainer/>
      <SimpleBackdrop openLoader={isActive}/>

       <SoftBox py={0} className="customerblock">
       <Grid container spacing={3}>
       <Grid item xs={12} lg={12} className="headerForm">
       
       <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
<img src={anmolLogo} alt="Logo" style={{ height: 100 }} />

<SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
 Customer Edit
</SoftTypography>

{/* This empty box ensures the text remains centered */}
<div style={{ width: 50 }}></div>
</SoftBox>


       <Grid>
                     {loaderspinner ? <div style={{
                       position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                       zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                     }}>
                       <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                     </div> : ""}
       </Grid>
       
       </Grid>
       </Grid>
       </SoftBox>
        
      <SoftBox className="bp formBG">
                <form noValidate onSubmit={handleSubmitForm}>
               <SoftBox py={3} className="customerblock">
                 <Grid container spacing={3}>
                   <Grid item xs={12} lg={12}>
                     <Card sx={{ overflow: "visible" }}>
                       <SoftBox p={3}>
                         <SoftTypography variant="h5" id="form_heading textUppercase">Customer Details</SoftTypography>
      
                         
      
                         <SoftBox mt={1}>
                           <Grid container spacing={3}>
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Name of Firm*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   name="firm_name"
                                   id="firm_name"
                                  //  error={formValues.firm_name.error} 
                                   value={formValues.firm_name}
                                   disabled={!isFieldEnabled('firm_name')}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('firm_name', wordCapital)}}
                                   
                                 />
                               </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Status of Firm*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftSelect
                                   name="firm_status"
                                   id="address"
                                   isDisabled={!isFieldEnabled('firm_status')}
                                   options={custTitle}
                                  value={[
                                    { value: formValues.firm_status, label: formValues.firm_status } // Set the selected state value here
                                  ]}
                                   onChange={(e) => handleFormChange('firm_status', e.value)}
                                   
                                 />
                               </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Street*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   name="street"
                                   id="street"
                                  inputProps={{maxLength: 60}}
                                  //  value={formValues.office_address?.value || ''}
                                  disabled={!isFieldEnabled('address')}
                                   value={formValues.street}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('street', wordCapital)}}
                                 onKeyDown={(e)=>{
                                                               if(e.target.value.length==60){
                                                                  if (!toast.isActive(toastId.current)) {
                                           toastId.current = toast.warning("Street Cannot be more than 60 characters", {
                                             className: "small-toast"
                                           });
                                         }
                                                               }
                                                             }}
                                 />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     PO Box
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   name="po_box"
                                   id="po_box"
                                   disabled={!isFieldEnabled('address')}
                                  //  value={formValues.office_address?.value || ''}
                                   value={formValues.po_box}
                                   onChange={(e) => handleFormChange('po_box', e.target.value)}
                                 
                                 />
                               </SoftBox>
                             </Grid>
                           </Grid>
                         </SoftBox>
      
                         <SoftBox mt={1}>
                           <Grid container spacing={3}>
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                    State Name*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftSelect
                                   isDisabled={!isFieldEnabled('address')}
                                   id="state"
                                   options = {customerState}
                                    value={[
                                      { value: formValues.state, label: formValues.state } // Set the selected state value here
                                    ]}
                                   onChange={(e) => handleFormChange('state', e.value)}
                                   size="medium"
                                  
                                    />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Pin Code*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="pin_code"
                                   name="pin_code"
                                   disabled={!isFieldEnabled('address')}
                                   value={formValues.pin_code}
                                   onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                    handleFormChange('pin_code', onlyNumbers);
                                  }}
                                  onKeyDown={(e)=>{
                                                                if(e.target.value.length==6){
                                                                   if (!toast.isActive(toastId.current)) {
                                            toastId.current = toast.warning("Pin Code Cannot be more than 6 characters", {
                                              className: "small-toast"
                                            });
                                          }
                                                                }
                                                              }}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     City*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   name="city"
                                   id="city"
                                   value={formValues.city}
                                   disabled={!isFieldEnabled('address')}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('city', wordCapital)}}
                                 />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     District Name*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                                                                         name="district_name"
                                                                                         id="district_name"
                                                                                         readOnly
                                                                                         disabled={!isFieldEnabled('address')}
                                                                                         value={formValues.district_name}
                                                                                         onClick={(e) =>{
                                                                                          setSelectedKeyName("zzdist");
                                                                                          let filteredData = zData
                                                                                          .map(item => item.zzdist)
                                                                                          .filter(value => value && value.trim() !== '');
                                                                                          setFilteredZone(filteredData)
                                                                                          setDialogOpen2(true)
                                                            
                                                                                          setSelectedZoneName('district_name');
                                                                                         }}
                                                                                       />
                               </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Block/Tehsil/Taluka/Mandal Name
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="block_tehsil"
                                   disabled={!isFieldEnabled('address')}
                                   value={formValues.block_tehsil}
                                   onChange={(e) => handleFormChange('block_tehsil', e.target.value)}
                                   size="medium" />
                               </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={3}>
                             <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Main Town/Village Name
                                   </SoftTypography>
                                 </SoftBox>
                                  <SoftInput
                                                                                       name="main_town_village"
                                                                                       id="main_town_village"
                                                                                      disabled={!isFieldEnabled('address')}
                                                                                      value={formValues.main_town_village}
                                                                                      onClick={(e) =>{
                                                                                        let filteredData = zData
                                                                                        .map(item => item.zztown)
                                                                                        .filter(value => value && value.trim() !== '');
                                                                                        setFilteredZone(filteredData)
                                                                                        setDialogOpen2(true)
                                                          
                                                                                        setSelectedZoneName('main_town_village');
                                                                                       }}
                                                                                       
                                                                                     />
                             </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={3}>
                             <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                   
                                   >
                                     Post office
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="post_office"
                                   disabled={!isFieldEnabled('address')}
                                   value={formValues.post_office}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('post_office', wordCapital)}}
                                   size="medium"
                                    />
                             </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Police Station
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="police_station"
                                   name="police_station"
                                   disabled={!isFieldEnabled('address')}
                                  //  error={formValues.police_station.error}
                                   value={formValues.police_station}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('police_station', wordCapital)}}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             {/* <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     disabled
                                   >
                                     Mobile.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="mobile"
                                   name="mobile"
                                  disabled={!isFieldEnabled("mobile")}
                                   value={formValues.mobile}
                                   inputProps={{maxLength:10}}
                                  //  disabled={!isFieldEnabled('mobile')}
                                  onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                    handleFormChange('mobile', onlyNumbers);
                                  }}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Email.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="email"
                                   name="email"
                                   disabled={!isFieldEnabled("email")}
                                   value={formValues.email}
                                   onChange={(e) => handleFormChange('email', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid> */}
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Name of Proprietor / Partners / Directors*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="proprietor_name"
                                   name="proprietor_name"
                                   disabled={!isFieldEnabled('proprietor_details')}
                                   value={formValues.proprietor_name}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('proprietor_name', wordCapital)}}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Proprietor Contact No:-(WhatsApp No.)*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="proprietor_mobile"
                                   name="proprietor_mobile"
                                   inputProps={{ maxLength: 10 }}
                                   disabled={!isFieldEnabled('proprietor_details')}
                                   value={formValues.proprietor_mobile || contactMobile}
                                   onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                    handleFormChange('proprietor_mobile', onlyNumbers);
                                  }}
                                  onKeyDown={(e)=>{
                                                                if(e.target.value.length==10){
                                                                   if (!toast.isActive(toastId.current)) {
                                            toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
                                              className: "small-toast"
                                            });
                                          }
                                                                }
                                                              }}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                   
                                   >
                                    Proprieter Email Id*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="proprietor_email"
                                   name="proprietor_email"
                                   disabled={!isFieldEnabled('proprietor_details')}
                                   value={formValues.proprietor_email || contactEmail}    
                                   onChange={(e) => handleFormChange('proprietor_email', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Date of Birth of Proprietor/Partner/Director*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="date"
                                   id="proprietor_dob"
                                   name="proprietor_dob"
                                   disabled={!isFieldEnabled('proprietor_details')}
                                   value={formatDate(formValues.proprietor_dob)}
                                   onChange={(e) => {
                                                                 const selectedDate = new Date(e.target.value);
                                                                 const today = new Date();
                                                               
                                                                 if (selectedDate > today) {
                                                                   if (!toast.isActive(toastId.current)) {
                                                                     toastId.current = toast.warning("DOB cannot be a future date", {
                                                                       className: "small-toast",
                                                                     });
                                                                   }
                                                                   handleFormChange('proprietor_dob', '');
                                                                   return; // don't update the state if it's an invalid future date
                                                                 }
                                                               
                                                                 const day = String(selectedDate.getDate()).padStart(2, '0');
                                                                 const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
                                                                 const year = selectedDate.getFullYear();
                                                               
                                                                 const formattedDate = `${year}${month}${day}`;
                                                                 handleFormChange('proprietor_dob', formattedDate);
                                                               }}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Name of Contact Person*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="contact_person"
                                   name="contact_person"
                                   disabled={!isFieldEnabled('contact_person_details')}
                                   value={formValues.contact_person}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('contact_person', wordCapital)}}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Contact Person Telephone.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   inputProps={{ maxLength: 11 }}
                                   id="contact_person_telephone"
                                   name="contact_person_telephone"
                                   disabled={!isFieldEnabled('contact_person_details')}
                                   value={formValues.contact_person_telephone}
                                   onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                    handleFormChange('contact_person_telephone', onlyNumbers);
                                  }}
                                  onKeyDown={(e)=>{
                                                                if(e.target.value.length==11){
                                                                   if (!toast.isActive(toastId.current)) {
                                            toastId.current = toast.warning("Telephone No Cannot be more than 11 digits", {
                                              className: "small-toast"
                                            });
                                          }
                                                                }
                                                              }}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Contact Person Mobile*.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="mobile"
                                   name="mobile"
                                   inputProps={{ maxLength: 10 }}
                                   disabled={!isFieldEnabled('contact_person_details')}
                                   value={formValues.contact_person_mobile}
                                   onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                    handleFormChange('contact_person_mobile', onlyNumbers);
                                  }}
                                  onKeyDown={(e)=>{
                                                                if(e.target.value.length==10){
                                                                   if (!toast.isActive(toastId.current)) {
                                            toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
                                              className: "small-toast"
                                            });
                                          }
                                                                }
                                                              }}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={3}>
                               <SoftBox mb={3}>
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Contact Person Email*
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="contact_person_email"
                                   name="contact_person_email"
                                   disabled={!isFieldEnabled('contact_person_details')}
                                   value={formValues.contact_person_email}
                                   onChange={(e) => handleFormChange('contact_person_email', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                            
                             
                           </Grid>
                         </SoftBox>
      
      
                       
                         
      
                         
      
                       </SoftBox>
                     </Card>
                   </Grid>
                 </Grid>
               </SoftBox>
      
               <SoftBox py={3} className="customerblock">
      <Grid container spacing={3}>
       <Grid item xs={12} lg={12}>
         <Card sx={{ overflow: "visible" }}>
           <SoftBox p={3}>
           <SoftTypography variant="h5" id="form_heading">Business Details</SoftTypography>
      
      
             <SoftBox mt={1}>
               <Grid container spacing={3}>
               <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     GSTIN No.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="gstn"
                                   name="gstn"
                                   error={panGSTError2}
                                   disabled={!isFieldEnabled('gstn')}
                                   value={formValues.gstn}
                                   size="medium"
                                    onChange={(e) => {
                                                                const gstn = e.target.value.trim();
                                                              
                                                                if (gstn === "") {
                                                                  setFormValues((prev) => ({
                                                                    ...prev,
                                                                    gstn: "",
                                                                    pan: "",
                                                                  }));
                                                                  return;
                                                                }
                                                              
                                                                const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
                                                              
                                                                if (gstnRegex.test(gstn)) {
                                                                  const panFromGstn = gstn.substring(2, 12); // Extract PAN
                                                                  console.log("pan is>> ", panFromGstn);
                                                                  setFormValues((prev) => ({
                                                                    ...prev,
                                                                    gstn: gstn,
                                                                    pan: panFromGstn,
                                                                  }));
                                                                  setPanGSTError2(false)
                                                                } else {
                                                                  if (!toast.isActive(toastId.current)) {
                                                                    toastId.current = toast.warning("Please fill a valid GSTIN number", {
                                                                      className: "small-toast",
                                                                    });
                                                                  }
                                                                  setPanGSTError2(true)
                                                                  setFormValues((prev) => ({
                                                                    ...prev,
                                                                    gstn: gstn,
                                                                    pan: "", // Clear PAN if GSTN is invalid
                                                                  }));
                                                                }
                                                              }}
                                   
                                   />
                               </SoftBox>
                             </Grid>

                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     PAN number*.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="pan"
                                   name="pan"
                                   error={panGSTError}
                                   disabled={!isFieldEnabled('pan')}
                                   value={formValues.pan}
                                    onChange={(e) => {
                                                                 const pan = e.target.value.trim().toUpperCase();
                                                                 const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                                                               
                                                                 if (pan === "") {
                                                                   handleFormChange('pan', pan);
                                                                   return;
                                                                 }
                                                               
                                                                 if (panRegex.test(pan)) {
                                                                   setFormValues((prev) => ({
                                                                     ...prev,
                                                                     pan: pan,
                                                                   }));
                                                                   setPanGSTError(false)
                                                                 } else {
                                                                   if (!toast.isActive(toastId.current)) {
                                                                     toastId.current = toast.warning("Please enter a valid PAN number", {
                                                                       className: "small-toast",
                                                                     });
                                                                   }
                                                                   setPanGSTError(true)
                                                                   setFormValues((prev) => ({
                                                                     ...prev,
                                                                     pan: pan,
                                                                   }));
                                                                 }
                                                               }}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     FSSAI No.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="fssi_regn_no"
                                   name="fssi_regn_no"
                                   disabled={!isFieldEnabled('fssai_details')}
                                   value={formValues.fssi_regn_no}
                                   onChange={(e) => handleFormChange('fssi_regn_no', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Aadhaar (mandatory for proprietership firm).
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="aadhaar"
                                   name="aadhaar"
                                   disabled={!isFieldEnabled('aadhar')}
                                   value={formValues.aadhaar}    
                                   onChange={(e) => handleFormChange('aadhaar', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     TAN number.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="tan"
                                   name="tan"
                                   disabled={!isFieldEnabled('tan')}
                                   value={formValues.tan}
                                   onChange={(e) => handleFormChange('tan', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     CIN ( applicable for  LTD / PVT / LLP) .
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="cin"
                                   name="cin"
                                   disabled={!isFieldEnabled('cin')}
                                   value={formValues.cin}
                                   onChange={(e) => handleFormChange('cin', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     ROC status of company whether exist of strike of
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftSelect
                                   type="text"
                                   id="pan"
                                   name="roc_status"
                                   isDisabled={!isFieldEnabled('roc_status')}
                                  value={[
                                      {value: formValues.roc_status, label: formValues.roc_status } // Set the selected state value here
                                  ]}
                                  //  value={formValues.roc_status.value}
                                   onChange={(e) => handleFormChange('roc_status', e.value)}
                                   size="medium"
                                   options={[
                                      {value: "Yes", label: "Yes"},
                                      {value: "No", label: "No"}
                                   ]}
                                   />
                               </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Investment Amount Plan for Anmol(Rs.)
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="inpln"
                                   name="inpln"
                                   disabled={!isFieldEnabled('inpln')}
                                   value={formValues.inpln}
                                   onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                    handleFormChange('inpln', onlyNumbers);
                                  }}
                                   size="medium"
                                   />
                               </SoftBox>
                             </Grid>
      
                             {/* <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Non-IT Return 
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftSelect
                                   id="inpln"
                                   name="inpln"
                                  
                                   value={[
                                    {value: formValues.non_it_return, label: formValues.non_it_return } // Set the selected state value here
                                   ]}
                                   options={[
                                    {value:"Yes", label:"Yes"},
                                    {value:"No", label:"No"}
                                   ]}
                                   onChange={(e) => handleFormChange('non_it_return', e.value)}
                                   size="medium"
                                   />
                               </SoftBox>
                             </Grid> */}
                             
      
      
               </Grid>
             </SoftBox>
      
           </SoftBox>
         </Card>
       </Grid>
      </Grid>
      </SoftBox>
      
      <SoftBox py={3} className="customerblock">
      <Grid container spacing={3}>
       <Grid item xs={12} lg={12}>
         <Card sx={{ overflow: "visible" }}>
           <SoftBox p={3}>
           <SoftTypography variant="h5" id="form_heading">Bank Details</SoftTypography>
      
      
             <SoftBox mt={1}>
               <Grid container spacing={3}>
               <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Bank Account No.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                                              type="text"
                                                              id="bank_account_number"
                                                              name="bank_account_number"
                                                             inputProps={{maxLength:20}}
                                                             disabled={!isFieldEnabled('bank_details')}
                                                              value={formValues.bank_account_number}
                                                              onChange={(e) => {
                                                               const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                               handleFormChange('bank_account_number', onlyNumbers);}}
                                                              size="medium"
                                                              onKeyDown={(e)=>{
                                                                                            if(e.target.value.length==20){
                                                                                               if (!toast.isActive(toastId.current)) {
                                                                        toastId.current = toast.warning("Account No Cannot be more than 20 digits", {
                                                                          className: "small-toast"
                                                                        });
                                                                      }
                                                                                            }
                                                                                          }}
                                                              />
                               </SoftBox>
                             </Grid>
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     IFSC Code.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="ifsc_code"
                                   name="ifsc_code"
                                   disabled={!isFieldEnabled('bank_details')}
                                   value={formValues.ifsc_code}
                                   onChange={(e) => handleFormChange('ifsc_code', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Bank Name.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="bank_name"
                                   name="bank_name"
                                   disabled={!isFieldEnabled('bank_details')}
                                   value={formValues.bank_name}
                                   onChange={(e) => {
                                    let wordCapital= capitalizeInitials(e.target.value)
                                    handleFormChange('bank_name', wordCapital)}}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Bank Branch Name.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="bank_branch_name"
                                   name="bank_branch_name"
                                   disabled={!isFieldEnabled('bank_details')}
                                   value={formValues.bank_branch_name}
                                   onChange={(e) => handleFormChange('bank_branch_name', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Undated Cheque No. 1.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="bank_branch_name"
                                   name="bank_branch_name"
                                   disabled={!isFieldEnabled('bank_details')}
                                   value={formValues.undated_cheque_1}
                                   onChange={(e) => handleFormChange('undated_cheque_1', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Undated Cheque No. 2.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="bank_branch_name"
                                   name="bank_branch_name"
                                   disabled={!isFieldEnabled('bank_details')}
                                   value={formValues.undated_cheque_2}
                                   onChange={(e) => handleFormChange('undated_cheque_2', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Undated Cheque No. 3.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="bank_branch_name"
                                   name="bank_branch_name"
                                   disabled={!isFieldEnabled('bank_details')}
                                   value={formValues.undated_cheque_3}
                                   onChange={(e) => handleFormChange('undated_cheque_3', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
                             <Grid item xs={12} sm={4}>
                               <SoftBox mb={3} id="mkcustomer">
                                 <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                   <SoftTypography
                                     component="label"
                                     variant="caption"
                                     fontWeight="bold"
                                     
                                   >
                                     Miscellaneous.
                                   </SoftTypography>
                                 </SoftBox>
                                 <SoftInput
                                   type="text"
                                   id="bank_branch_name"
                                   name="bank_branch_name"
                                   disabled={!isFieldEnabled('bank_details')}
                                   value={formValues.miscellaneous}
                                   onChange={(e) => handleFormChange('miscellaneous', e.target.value)}
                                   size="medium"
                                   
                                   />
                               </SoftBox>
                             </Grid>
      
               </Grid>
             </SoftBox>
      
           </SoftBox>
         </Card>
       </Grid>
      </Grid>
      </SoftBox>
      
      <SoftBox py={3} className="customerblock">
      <Grid container spacing={3}>
       <Grid item xs={12} lg={12}>
         <Card sx={{ overflow: "visible" }}>
           <SoftBox p={3}>
           <SoftTypography variant="h5" id="form_heading" style={{marginBottom:'8px'}}>Other Information & Infastructure Details</SoftTypography>
           <SoftTypography variant="p" >Other Products details in which the Customer is dealing with, if any</SoftTypography>
           <SoftBox mt={1}>
           {formValues.companies.map((company, index) => (
            <div style={{borderBottom: "1px dashed rgb(233, 233, 233)", paddingBottom: "16px"}} key={index}>
           <Grid container spacing={3} key={index}>
          <React.Fragment key={index} >      
            <Grid item xs={12} sm={4}>
              <SoftBox >
                <SoftTypography variant="caption" fontWeight="bold">Name of the Company</SoftTypography>
                <SoftInput
                  type="text"
                  value={company.name_of_company}
                  disabled={!isFieldEnabled('companies')}
                  onChange={(e) => handleFormChange('name_of_company', e.target.value, index)}
                />
              </SoftBox>
            </Grid>
            <Grid item xs={12} sm={4}>
              <SoftBox >
                <SoftTypography variant="caption" fontWeight="bold">Brand</SoftTypography>
                <SoftInput
                  type="text"
                  value={company.company_brand}
                  disabled={!isFieldEnabled('companies')}
                  onChange={(e) => handleFormChange('company_brand', e.target.value, index)}
                />
              </SoftBox>
            </Grid>
            <Grid item xs={12} sm={4}>
              <SoftBox>
                <SoftTypography variant="caption" fontWeight="bold">Monthly Turnover</SoftTypography>
                <SoftInput
                  type="text"
                  inputProps={{maxLength: 8}}
                  value={company.monthly_turnover}
                  disabled={!isFieldEnabled('companies')}
                  onChange={(e) => handleFormChange('monthly_turnover', e.target.value, index)}
                />
              </SoftBox>
            </Grid>
          </React.Fragment>
          </Grid>
          </div>
        ))}
      
      
      
      {/* <Grid container spacing={1}>
        <Grid item xs={6} sm={4}>
          <SoftButton variant="contained" color="info"  onClick={addRow}>
            Add Row
          </SoftButton>
        </Grid>
        {formValues.companies.length > 1 && (
          <Grid item xs={6} sm={4}>
            <SoftButton variant="contained" color="error"  onClick={() => removeRow(formValues.companies.length - 1)}>
              Remove
            </SoftButton>
          </Grid>
        )}
      </Grid> */}
      
      <SoftBox mt={2} style={{display: "flex", justifyContent: "flex-end"}}>
      <SoftButton variant="contained" disabled={!isFieldEnabled('companies')} color="info"  onClick={addRow}>
            Add Row
          </SoftButton>
                {formValues.companies.length > 1 && (
                 
                 <SoftButton variant="contained" style={{marginLeft:'12px'}} color="error"  onClick={() => removeRow(formValues.companies.length - 1)}>
                 <DeleteIcon/>
               </SoftButton>
                 
                )}
                </SoftBox>
           </SoftBox>
            
           </SoftBox>
         </Card>
       </Grid>
      </Grid>
      </SoftBox>
      
      <SoftBox py={3} className="customerblock">
      <Grid container spacing={3}>
      <Grid item xs={12} lg={12}>
      <Card sx={{ overflow: "visible" }}>
      <SoftBox p={3}>
      <SoftTypography variant="h5" id="form_heading">Storage details</SoftTypography>
      <SoftBox mt={1}>
      <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">
            Godown Area (sqft)
          </SoftTypography>
          <Box display="flex" alignItems="center" gap={1}>
            <SoftInput
              type="text"
              disabled={!isFieldEnabled('godown_details')}
              value={formValues.godown_area.split(" ")[0]}
              onChange={(e) => handleFormChange('godown_area', e.target.value)}
              sx={{ width: '70%' }} // adjust main input width
            />
            <TextField
              variant="outlined"
              size="small"
              placeholder="Unit"
              value={godownUnit}
              disabled={!isFieldEnabled('godown_details')}
              onClick={(e)=>{
                if(isFieldEnabled('godown_details')){

                  setDialogOpen(true)
                }else{
                  return
                }
              } }
              sx={{ width: '30%' }} // size of the extra box
            />
          </Box>
        </SoftBox>
      </Grid>
      
            <Grid item xs={12} sm={4}>
              <SoftBox mb={3}>
                <SoftTypography variant="caption" fontWeight="bold">Godown Type</SoftTypography>
                <SoftInput
              type="text"
              value={formValues.godown_type}
              disabled={!isFieldEnabled('godown_details')}
              onChange={(e) => handleFormChange('godown_type', e.target.value)}
              
            />
              </SoftBox>
            </Grid>
            <Grid item xs={12} sm={4}>
              <SoftBox mb={3}>
                <SoftTypography variant="caption" fontWeight="bold">RCC Structure</SoftTypography>
                <SoftInput
              type="text"
              value={formValues.rcc_structure}
              disabled={!isFieldEnabled('godown_details')}
              onChange={(e) => handleFormChange('rcc_structure', e.target.value)}
              
            />
              </SoftBox>
            </Grid>
            <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Delivery Vehicle Type</SoftTypography>
          <FormGroup sx={{displaye:'flex', justifyContent:'space-between'}}>
            <FormControlLabel
              control={
                <Checkbox
                size="small"
                  checked={formValues.del_type_rickshaw === "X"}
                  disabled={!isFieldEnabled("godown_details")}
                  onChange={(e) =>
                    handleFormChange('del_type_rickshaw', e.target.checked ? "X" : "")
                  }
                />
              }
              label={
                <SoftTypography variant="caption">Rickshaw</SoftTypography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                size="small"
                  checked={formValues.del_type_van === "X"}
                  disabled={!isFieldEnabled("godown_details")}
                  onChange={(e) =>
                    handleFormChange('del_type_van', e.target.checked ? "X" : "")
                  }
                />
              }
              label={
                <SoftTypography variant="caption">Auto Van</SoftTypography>
              }
            />
          </FormGroup>
        </SoftBox>
      </Grid>
      
      {formValues.del_type_van === "X" && (
        <Grid item xs={12} sm={4}>
          <SoftBox mb={3}>
            <SoftTypography variant="caption" fontWeight="bold">Auto Van Model</SoftTypography>
            <SoftInput
              type="text"
              disabled={!isFieldEnabled('godown_details')}
              value={formValues.model_no_van || ""}
              onChange={(e) => handleFormChange("model_no_van", e.target.value)}
            />
          </SoftBox>
        </Grid>
      )}
      
      <Grid container spacing={2} justifyContent="flex-start" style={{ marginLeft: '1%' }}>
        <Grid item xs={10} sm={3}>
          <SoftBox mb={3}>
            <SoftTypography variant="caption" fontWeight="bold">Salesman 1</SoftTypography>
            <SoftInput
              type="text"
              value={formValues.customer_salesman_1}
              disabled={!isFieldEnabled('godown_details')}
              onChange={(e) => {
                let wordCapital= capitalizeInitials(e.target.value)
                handleFormChange('customer_salesman_1', wordCapital)}}
            />
          </SoftBox>
        </Grid>
        
        <Grid item xs={12} sm={3}>
          <SoftBox mb={3}>
            <SoftTypography variant="caption" fontWeight="bold">Mobile 1</SoftTypography>
            <SoftInput
              type="text"
              inputProps={{maxLength:10}}
              value={formValues.customer_salesman_no_1}
              disabled={!isFieldEnabled('godown_details')}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                handleFormChange('customer_salesman_no_1', onlyNumbers);
              }}
            />
          </SoftBox>
        </Grid>
      
        <Grid item xs={12} sm={3}>
          <SoftBox mb={3}>
            <SoftTypography variant="caption" fontWeight="bold">Salesman 2</SoftTypography>
            <SoftInput
              type="text"
              value={formValues.customer_salesman_2}
              disabled={!isFieldEnabled('godown_details')}
              onChange={(e) => {
                let wordCapital= capitalizeInitials(e.target.value)
                handleFormChange('customer_salesman_2', wordCapital)}}
            />
          </SoftBox>
        </Grid>
      
        <Grid item xs={12} sm={3}>
          <SoftBox mb={3}>
            <SoftTypography variant="caption" fontWeight="bold">Mobile 2</SoftTypography>
            <SoftInput
              type="text"
              value={formValues.customer_salesman_no_2}
              inputProps={{maxLength:10}}
              disabled={!isFieldEnabled('godown_details')}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                handleFormChange('customer_salesman_no_2', onlyNumbers);
              }}
            />
          </SoftBox>
        </Grid>
      </Grid>
      
            <Grid item xs={12} sm={4}>
              <SoftBox mb={3}>
                <SoftTypography variant="caption" fontWeight="bold">Week Off Day Followed by Customer.</SoftTypography>
                <SoftInput
                  type="text"
                 value={formValues.customer_weekoff}
                 disabled={!isFieldEnabled('godown_details')}
                  onChange={(e) => handleFormChange( 'customer_weekoff', e.target.value)}
                />
              </SoftBox>
            </Grid>
      </Grid>
      </SoftBox>
      </SoftBox>
      </Card>
      </Grid>
      </Grid>
      </SoftBox>
      
      {customerType!=="railway_distributor" && customerType!=="super_stockist" && 
      
      <SoftBox py={3} className="customerblock">
      <Grid container spacing={3}>
      <Grid item xs={12} lg={12}>
      <Card sx={{ overflow: "visible" }}>
      <SoftBox p={3}>
      <SoftTypography variant="h5" id="form_heading">Market Details</SoftTypography>
      
      <Grid container spacing={3} >
        {Object.keys(formValues.marketDetails).map((day) => (
          <Grid item xs={12} key={day} style={{paddingTop: "0px", marginTop: "15px"}}>
            <Card sx={{ overflow: "hidden" }}>
              <SoftBox p={0}>
              <SoftTypography
              variant="h6"
              component="label"
              fontWeight="bold"
              
              style={{padding: "10px", marginBottom:"8px", backgroundColor:'#ccc', }}>{day}</SoftTypography>
                {formValues.marketDetails[day].map((row, index) => {
                
                  return(
      <>
                  <Grid container spacing={1} key={index} style={{padding: "20px 20px", borderBottom: "1px dashed #ccc", position:'relative', display:'flex',flexWrap: 'nowrap', overflowX: 'auto'}}>
                   
                    <Grid item xs={2}>
                    <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Beat Name</SoftTypography>
                      <SoftInput
                      type="text"
                      disabled={!isFieldEnabled('marketDetails')}
                        value={row.beatName_1}
                        onChange={(e) => handleFormChange("beatName_1", e.target.value, index, day)}
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={2}>
                    <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Distance from Godown</SoftTypography>
                      <SoftInput
                        type="number"
                        disabled={!isFieldEnabled('marketDetails')}
                        inputProps={{ step: "0.01" }}
                        value={row.distanceFromGodown_1}
                        onChange={(e) => handleFormChange("distanceFromGodown_1", e.target.value, index, day)}
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={2}>
                    <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Expected Daily Sales</SoftTypography>
                      <SoftInput
                       type="number"
                       disabled={!isFieldEnabled('marketDetails')}
                       inputProps={{ step: "0.01" }}
                       value={row.expectedDailySales_1}
                        onChange={(e) => handleFormChange("expectedDailySales_1", e.target.value, index,day)}
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={2}>
                    <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Retailer</SoftTypography>
                      <SoftInput
                       type="number"
                       disabled={!isFieldEnabled('marketDetails')}
                      value={row.retailer_1}
                        onChange={(e) => handleFormChange("retailer_1", e.target.value, index,day)}
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={2}>
                    <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Wholesaler</SoftTypography>
                      <SoftInput
                        type="number"
                        disabled={!isFieldEnabled('marketDetails')}
                        value={row.wholesaler_1}
                        onChange={(e) => handleFormChange("wholesaler_1", e.target.value, index, day)}
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={2}>
                    <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Frequency of Visit (Weekly)</SoftTypography>
                      <SoftInput
                       type="text"
                       disabled={!isFieldEnabled('marketDetails')}
                       value={row.frequencyOfVisit_1}
                        onChange={(e) => handleFormChange("frequencyOfVisit_1", e.target.value, index, day)}
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={2}>
                    <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Ready Stock or Order booking</SoftTypography>
                      <SoftInput
                        type="text"
                        disabled={!isFieldEnabled('marketDetails')}
                       value={row.readyStockOrOrderBooking_1}
                        onChange={(e) => handleFormChange("readyStockOrOrderBooking_1", e.target.value, index, day)}
                        size="medium"
                      />
                    </Grid>
                    {/* {formValues.marketDetails[day].length > 1 && index!==0 && (
                       <div style={{width: "30px", height: "30px", backgroundColor: "#efefef", position:'absolute', right:'10px', cursor:'pointer', 
                       top:'25px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center'}} onClick={() => removeRowMarket(day, index)}>
                       <CloseIcon/>
                     </div>
                      // <Grid item xs={2}>
                      //   <SoftButton variant="contained" color="error" onClick={() => removeRowMarket(day, index)}>
                      //     <DeleteIcon/>
                      //   </SoftButton>
                      // </Grid>
                    )} */}
                  </Grid>
      
                  <Grid container spacing={1} key={index} style={{padding: "20px 20px", borderBottom: "1px dashed #ccc", position:'relative',display:'flex',flexWrap: 'nowrap', overflowX: 'auto'}}>
                   
                   <Grid item xs={2}>
                   <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Beat Name</SoftTypography>
                     <SoftInput
                     type="text"
                     disabled={!isFieldEnabled('marketDetails')}
                       value={row.beatName_2}
                       onChange={(e) => handleFormChange("beatName_2", e.target.value, index, day)}
                       size="medium"
                     />
                   </Grid>
                   <Grid item xs={2}>
                   <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Distance from Godown</SoftTypography>
                     <SoftInput
                       type="number"
                       disabled={!isFieldEnabled('marketDetails')}
                       inputProps={{ step: "0.01" }}
                       value={row.distanceFromGodown_2}
                       onChange={(e) => handleFormChange("distanceFromGodown_2", e.target.value, index, day)}
                       size="medium"
                     />
                   </Grid>
                   <Grid item xs={2}>
                   <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Expected Daily Sales</SoftTypography>
                     <SoftInput
                       type="number"
                       disabled={!isFieldEnabled('marketDetails')}
                       inputProps={{ step: "0.01" }}
                      value={row.expectedDailySales_2}
                       onChange={(e) => handleFormChange("expectedDailySales_2", e.target.value, index,day)}
                       size="medium"
                     />
                   </Grid>
                   <Grid item xs={2}>
                   <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Retailer</SoftTypography>
                     <SoftInput
                      type="number"
                      disabled={!isFieldEnabled('marketDetails')}
                     value={row.retailer_2} 
                       onChange={(e) => handleFormChange("retailer_2", e.target.value, index,day)}
                       size="medium"
                     />
                   </Grid>
                   <Grid item xs={2}>
                   <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Wholesaler</SoftTypography>
                     <SoftInput
                       type="number"
                       disabled={!isFieldEnabled('marketDetails')}
                       value={row.wholesaler_2}
                       onChange={(e) => handleFormChange("wholesaler_2", e.target.value, index, day)}
                       size="medium"
                     />
                   </Grid>
                   <Grid item xs={2}>
                   <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Frequency of Visit (Weekly)</SoftTypography>
                     <SoftInput
                      type="text"
                      disabled={!isFieldEnabled('marketDetails')}
                      value={row.frequencyOfVisit_2}
                       onChange={(e) => handleFormChange("frequencyOfVisit_2", e.target.value, index, day)}
                       size="medium"
                     />
                   </Grid>
                   <Grid item xs={2}>
                   <SoftTypography variant="caption" fontSize="10px" fontWeight="bold">Ready Stock or Order booking</SoftTypography>
                     <SoftInput
                       type="text"
                       disabled={!isFieldEnabled('marketDetails')}
                      value={row.readyStockOrOrderBooking_2}
                       onChange={(e) => handleFormChange("readyStockOrOrderBooking_2", e.target.value, index, day)}
                       size="medium"
                     />
                   </Grid>
                   {/* {formValues.marketDetails[day].length > 1 && index!==0 && (
                      <div style={{width: "30px", height: "30px", backgroundColor: "#efefef", position:'absolute', right:'10px', cursor:'pointer', 
                      top:'25px', borderRadius:'50%', display:'flex', justifyContent:'center', alignItems:'center'}} onClick={() => removeRowMarket(day, index)}>
                      <CloseIcon/>
                    </div>
                     // <Grid item xs={2}>
                     //   <SoftButton variant="contained" color="error" onClick={() => removeRowMarket(day, index)}>
                     //     <DeleteIcon/>
                     //   </SoftButton>
                     // </Grid>
                   )} */}
                 </Grid>
      </>
      
                  
                  )
               })}
                {/* <SoftBox  p={2}>
                  <SoftButton variant="contained" color="info" onClick={() => addRowMarket(day)}>
                    Add Row
                  </SoftButton>
                </SoftBox> */}
              </SoftBox>
            </Card>
          </Grid>
        ))}
      </Grid>
      
      
      </SoftBox>
      </Card>
      </Grid>
      </Grid>
      </SoftBox>
      }
      
      
               <SoftBox py={3} className="customerblock">
      <Grid container spacing={3}>
       <Grid item xs={12} lg={12}>
         <Card sx={{ overflow: "visible" }}>
           <SoftBox p={3}>
             {/* Submit Button */}
             <Grid container justifyContent="flex-end" mt={2}>
               <Grid item>
                 <SoftButton disabled={panGSTError||panGSTError2} type="submit" variant="contained" color="primary">
                   Save & Continue
                 </SoftButton>
               </Grid>
             </Grid>
           </SoftBox>
         </Card>
       </Grid>
      </Grid>
      </SoftBox>
      
               </form>
      
               <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <SimpleBackdrop openLoader={searchLoader} />
                                     <DialogTitle>Select an Option</DialogTitle>
                                     <DialogContent>
                     
                                     <input
                               type="text"
                               placeholder="Search..."
                               value={searchTerm}
                               onChange={(e) => setSearchTerm(e.target.value)}
                               style={{
                                 width: "100%",
                                 padding: "5px",
                                 marginBottom: "10px",
                                 fontSize: "12px",
                               }}
                             />
                              <SoftButton
                           onClick={() => handleFormChange('godown_unit', "")}
                           style={{
                             marginBottom: "10px",
                             backgroundColor: "#ccc",
                             border: "none",
                             padding: "5px 10px",
                             fontSize: "12px",
                             cursor: "pointer",
                             borderRadius: "4px"
                           }}
                         >
                           Clear Selection
                         </SoftButton>
                                     <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                     <thead>
                                     <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                             <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                                             <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                           </tr>
                                         </thead>
                                         <tbody>
                                           {kdsdata &&
                                             filteredData?.map((item, index) => (
                                               <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleFormChange('godown_unit',item.value)}>
                                                 <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                                                 <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                                               </tr>
                                             ))}
                                         </tbody>
                                       </Table>
                                     </DialogContent>
                                   </Dialog> 

                <Dialog open={dialogOpen2} onClose={() => setDialogOpen2(false)}>
                          <SimpleBackdrop openLoader={searchLoader} />
                                                                             <DialogTitle>Select an Option</DialogTitle>
                                                                             <DialogContent>
                                                             
                                                                             <input
                                                                       type="text"
                                                                       placeholder="Search..."
                                                                       value={searchTerm2}
                                                                       onChange={(e) => setSearchTerm2(e.target.value)}
                                                                       style={{
                                                                         width: "100%",
                                                                         padding: "5px",
                                                                         marginBottom: "10px",
                                                                         fontSize: "12px",
                                                                       }}
                                                                     />
                                                                      <SoftButton
                                                                   onClick={() => handleFormChange(selectedZoneName, "")}
                                                                   style={{
                                                                     marginBottom: "10px",
                                                                     backgroundColor: "#ccc",
                                                                     border: "none",
                                                                     padding: "5px 10px",
                                                                     fontSize: "12px",
                                                                     cursor: "pointer",
                                                                     borderRadius: "4px"
                                                                   }}
                                                                 >
                                                                   Clear Selection
                                                                 </SoftButton>
                                                                             <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                                                             <thead>
                                                                             <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                                                                     <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                                                                                   </tr>
                                                                                 </thead>
                                                                                 <tbody>
                                                         {
                                                          filteredZone.filter(
                                                            (item) =>
                                                              item.toLowerCase().includes(debouncedSearch.toLowerCase())
                                                          )
                                                           .map((item, idx) => (
                                                                 <tr
                                                                   key={idx}
                                                                   style={{ whiteSpace: 'nowrap', fontSize: "12px" }}
                                                                   onClick={() => handleFormChange(selectedZoneName, item)}
                                                                 >
                                                                   <td style={{ backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item}</td>
                                                                 </tr>
                                                               )
                                                             )
                                                         }
                                                       </tbody>
                                                                               </Table>
                                                                             </DialogContent>
                                                                           </Dialog>                      
               </SoftBox>
        
     </Grid>
     </>
    )
}

export default CustomerFormEdit